import { render, staticRenderFns } from "./share.vue?vue&type=template&id=6bef51c1&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style1 from "./share.vue?vue&type=style&index=1&id=6bef51c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef51c1",
  null
  
)

export default component.exports